import Footer from "./Footer";
import {useEffect, useState} from "react";
import {useRestClient} from "../../client/SpmRestClient";
import {Container} from "react-bootstrap";

export default function TermsPage() {
	const restClient = useRestClient();
	const [terms, setTerms] = useState<string>();

	const loadTerms = () => {
		restClient.terms().then((t) => setTerms(t.content))
	};

	useEffect(loadTerms, []);

	return (
		<Container>
			<h1>Podmínky užití</h1>
			{
				terms && <div
					dangerouslySetInnerHTML={{
						__html: terms.replace(/\n/gi, '<br/>'),
					}}
				/>
			}
			<Footer/>
		</Container>
	);
};

